// @flow
export { default } from './EventComment';



// WEBPACK FOOTER //
// ./src/components/event/EventComment/index.js